import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { MessagesModule }       from '../../app-lite/messages/messages.module';
import { SharedModule }         from '../../app-lite/shared/shared.module';
import { XeroCountryComponent } from './xero.country.component';
import { XeroSignInComponent }  from './xero.sign-in.component';
import { XeroSignupComponent }  from './xero.signup.component';
import { XeroStates }           from './xero.states';

@NgModule({
  declarations: [
    XeroCountryComponent,
    XeroSignInComponent,
    XeroSignupComponent
  ],
  entryComponents: [
    XeroSignInComponent
  ],
  exports: [
    XeroSignInComponent
  ],
  imports: [
    UIRouterModule.forChild({ states: XeroStates }),

    MessagesModule,
    SharedModule
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class XeroModule {}
